/* eslint-disable react/jsx-filename-extension */
import * as React from 'react';
import cx from 'classnames';
import Heading from 'components/Heading';
import Text, { TextColor, TextSize, TextAlign } from 'components/Text';

export type Props = {
  children?: string | React.ReactElement;
  className?: string;
  subtext?: string | React.ReactElement;
  subtle?: boolean;
  subtleTextColor?: TextColor;
  textSize?: TextSize;
  subtextSize?: TextSize;
  subtextColor?: TextColor;
  align?: TextAlign;
};

export default function TextWithSubtext({
  children,
  className,
  subtext,
  subtle,
  subtleTextColor = 'inherit',
  textSize,
  subtextSize,
  subtextColor = 'graphite',
  align = 'inherit',
}: Props) {
  return (
    <div className={cx('TextWithSubtext', className)}>
      {subtle ? (
        <Text
          element="div"
          size={textSize ?? 'small'}
          truncate
          color={subtleTextColor}
          align={align}
        >
          {children}
        </Text>
      ) : (
        <Heading flush level="2" levelStyle="5">
          <Text truncate align={align}>
            {children}
          </Text>
        </Heading>
      )}
      {subtext && (
        <Text color={subtextColor} size={subtextSize ?? 'xxsmall'} truncate align={align}>
          {subtext}
        </Text>
      )}
    </div>
  );
}
